module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAAA1BMVEUAra0UtCArAAAACklEQVQIHWMAAgAABAABDTukuQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/score_input_menu_bg.png
// module id = 362
// module chunks = 0